import type {
  TableColumn,
  TableRowData,
  TableSortKey,
} from '-/Custom/Table.types';

const defaultSortFunction = (
  a: string | number,
  b: string | number,
): number => {
  if (typeof a === 'number' && typeof b === 'number') {
    return a - b;
  }

  if (typeof a === 'string' && typeof b === 'string') {
    return a.localeCompare(b);
  }

  return 0;
};

export default function sortTable(
  rows: TableRowData[],
  columns: TableColumn[],
  sortKeys: TableSortKey[],
  isNumericSort = false,
): TableRowData[] {
  const columnMap = new Map(
    columns.map((column) => [column.key, column.sortFunction]),
  );

  return [...rows].sort((a, b) => {
    let result = 0;

    sortKeys.forEach((sortKey) => {
      if (result === 0) {
        const key = Object.keys(sortKey)[0];
        const order = sortKey[key];

        const sortFunction = columnMap.get(key) || defaultSortFunction;

        let valueA = a[key];
        let valueB = b[key];

        if (isNumericSort) {
          valueA = Number.parseFloat(valueA) || 0;
          valueB = Number.parseFloat(valueB) || 0;
        }

        if (sortFunction) {
          result = sortFunction(valueA, valueB);
          if (result !== 0) result = order === 'asc' ? result : -result;
        } else {
          if (valueA < valueB) result = order === 'asc' ? -1 : 1;
          if (valueA > valueB) result = order === 'asc' ? 1 : -1;
        }
      }
    });

    return result;
  });
}
